import React, { useEffect, useState } from "react";
import SetAlarm from "./set-alarm";
import SisLoader from "../../../widgets/loader";
import { post } from "../../../services/services";
import { ApiURL } from "../../../services/apiConstants";

function AddAlarmConditions() {
  const [loader, set_loader] = useState(false);
  const [errors, set_errors] = useState();
  const [main_exhaust_temp, set_main_exhaust_temp] = useState({
    max: null,
    orange: null,
    red: null,
  });
  const [scavenge_box_temp, set_scavenge_box_temp] = useState({
    max: null,
    orange: null,
    red: null,
  });
  const [jacket_water_temp, set_jacket_water_temp] = useState({
    max: null,
    orange: null,
    red: null,
  });
  const [piston_cooling_oil_out_temp, set_piston_cooling_oil_out_temp] = useState({
    max: null,
    orange: null,
    red: null,
  });
  const [fuel_rack, set_fuel_rack] = useState({
    max: null,
    orange: null,
    red: null,
  });
  const [fuel_oil_inlet, set_fuel_oil_inlet] = useState({
    max: null,
    orange: null,
    red: null,
  });
  const [scavenge_air_inlet, set_scavenge_air_inlet] = useState({
    max: null,
    orange: null,
    red: null,
  });
  const [lube_oil_inlet, set_lube_oil_inlet] = useState({
    max: null,
    orange: null,
    red: null,
  });
  const [egb_inlet, set_egb_inlet] = useState({
    max: null,
    orange: null,
    red: null,
  });
  const [egb_outlet, set_egb_outlet] = useState({
    max: null,
    orange: null,
    red: null,
  });
  const [exh_in, set_exh_in] = useState({ max: null, orange: null, red: null });
  const [exh_out, set_exh_out] = useState({
    max: null,
    orange: null,
    red: null,
  });
  const [air_in, set_air_in] = useState({ max: null, orange: null, red: null });
  const [air_out, set_air_out] = useState({
    max: null,
    orange: null,
    red: null,
  });
  const [fuel_oil_inlet_to_engine, set_fuel_oil_inlet_to_engine] = useState({
    max: null,
    orange: null,
    red: null,
  });
  const [auxi_exhaust_temp, set_auxi_exhaust_temp] = useState({
    max: null,
    orange: null,
    red: null,
  });

  const ALARM_VIEW_API = async () => {
    try {
      const FORM_DATA = new FormData();
      post(ApiURL.view_alarm_conditions_st, FORM_DATA).then((res) => {
        const alarm_condition_data = res?.alarm_condition_data || {};
        if (res?.status == true && alarm_condition_data) {
          set_main_exhaust_temp(JSON.parse(alarm_condition_data?.main_exhaust_temp));
          set_scavenge_box_temp(JSON.parse(alarm_condition_data?.scavenge_box_temp));
          set_jacket_water_temp(JSON.parse(alarm_condition_data?.jacket_water_temp));
          set_piston_cooling_oil_out_temp(
            JSON.parse(alarm_condition_data?.piston_cooling_oil_out_temp)
          );
          set_fuel_rack(JSON.parse(alarm_condition_data?.fuel_rack));
          set_fuel_oil_inlet(JSON.parse(alarm_condition_data?.fuel_oil_inlet));
          set_scavenge_air_inlet(JSON.parse(alarm_condition_data?.scavenge_air_inlet));
          set_lube_oil_inlet(JSON.parse(alarm_condition_data?.lube_oil_inlet));
          set_egb_inlet(JSON.parse(alarm_condition_data?.egb_inlet));
          set_egb_outlet(JSON.parse(alarm_condition_data?.egb_outlet));
          set_exh_in(JSON.parse(alarm_condition_data?.exh_in));
          set_exh_out(JSON.parse(alarm_condition_data?.exh_out));
          set_air_in(JSON.parse(alarm_condition_data?.air_in));
          set_air_out(JSON.parse(alarm_condition_data?.air_out));
          set_fuel_oil_inlet_to_engine(JSON.parse(alarm_condition_data?.fuel_oil_inlet_to_engine));
          set_auxi_exhaust_temp(JSON.parse(alarm_condition_data?.auxi_exhaust_temp));
        } else {
          const errors = res?.errors || {};
          set_errors(errors);
        }
      });
    } finally {
    }
  };

  useEffect(() => {
    ALARM_VIEW_API();
  }, []);

  return (
    <>
      {loader ? (
        <SisLoader />
      ) : (
        <>
          <div className="white-container">
            <div style={{ margin: "6px 0px" }}>
              <h3>Main Engine Details </h3>
            </div>

            <div className="row">
              <div className="col-6">
                <div className="input-box">
                  <label>Main Exhaust Temp</label>
                  <SetAlarm get_json={main_exhaust_temp} set_json={set_main_exhaust_temp} />
                </div>
              </div>
              <div className="col-6">
                <div className="input-box">
                  <label>Scavenge Box Temp</label>
                  <SetAlarm get_json={scavenge_box_temp} set_json={set_scavenge_box_temp} />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-6">
                <div className="input-box">
                  <label>Jacket Water Temp</label>
                  <SetAlarm get_json={jacket_water_temp} set_json={set_jacket_water_temp} />
                </div>
              </div>
              <div className="col-6">
                <div className="input-box">
                  <label>Piston Cooling oil out Temp </label>
                  <SetAlarm
                    get_json={piston_cooling_oil_out_temp}
                    set_json={set_piston_cooling_oil_out_temp}
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-6">
                <div className="input-box">
                  <label>Fuel Rack</label>
                  <SetAlarm get_json={fuel_rack} set_json={set_fuel_rack} />
                </div>
              </div>
              <div className="col-6">
                <div className="input-box">
                  <label>Fuel oil Inlet Temp</label>
                  <SetAlarm get_json={fuel_oil_inlet} set_json={set_fuel_oil_inlet} />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-6">
                <div className="input-box">
                  <label>Scavenge Air Inlet Temp</label>
                  <SetAlarm get_json={scavenge_air_inlet} set_json={set_scavenge_air_inlet} />
                </div>
              </div>
              <div className="col-6">
                <div className="input-box">
                  <label>Lube Oil inlet Temp</label>
                  <SetAlarm get_json={lube_oil_inlet} set_json={set_lube_oil_inlet} />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-6">
                <div className="input-box">
                  <label>EGB Inlet Temp</label>
                  <SetAlarm get_json={egb_inlet} set_json={set_egb_inlet} />
                </div>
              </div>
              <div className="col-6">
                <div className="input-box">
                  <label>EGB outlet</label>
                  <SetAlarm get_json={egb_outlet} set_json={set_egb_outlet} />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-6">
                <div className="input-box">
                  <label>T/C Exhaust Inlet Temp</label>
                  <SetAlarm get_json={exh_in} set_json={set_exh_in} />
                </div>
              </div>
              <div className="col-6">
                <div className="input-box">
                  <label>T/C Exhaust Outlet Temp</label>
                  <SetAlarm get_json={exh_out} set_json={set_exh_out} />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-6">
                <div className="input-box">
                  <label>Air Inlet Temperature Air Cooler</label>
                  <SetAlarm get_json={air_in} set_json={set_air_in} />
                </div>
              </div>
              <div className="col-6">
                <div className="input-box">
                  <label>Air Outlet Temperature Air Cooler</label>
                  <SetAlarm get_json={air_out} set_json={set_air_out} />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-6">
                <div className="input-box">
                  <label>Fuel oil Inlet to engine Temp</label>
                  <SetAlarm
                    get_json={fuel_oil_inlet_to_engine}
                    set_json={set_fuel_oil_inlet_to_engine}
                  />
                </div>
              </div>
            </div>

            <div style={{ margin: "6px 0px" }}>
              <h3>Auxiliary Engine Details </h3>
            </div>

            <div className="row">
              <div className="col-6">
                <div className="input-box">
                  <label>Auxiliary exhust Temp</label>
                  <SetAlarm get_json={auxi_exhaust_temp} set_json={set_auxi_exhaust_temp} />
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default AddAlarmConditions;
